import { useCallback } from 'react';
import { useStationsOperations } from 'entities/stations';
import {
  useGetStationByCode,
  useOperations,
  useStations,
  useAllStations
} from 'store/features/stations';

import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';

import { IStation } from 'dataSources/Typicode/stations/types';

import { STATIONS_AMPLITUDE_EVENTS } from 'entities/stations';
import { EMPTY_ARRAY } from 'common/constants';

export const useAddFavouriteStation = () => {
  const getStationByCode = useGetStationByCode();
  const stations = useStations() || EMPTY_ARRAY;
  const allStations = useAllStations() || EMPTY_ARRAY;
  const {
    getFavouriteStations,
    addFavouriteStations,
  } = useStationsOperations();
  const { updateStations, updateAllStations } = useOperations();

  const changeStations = useCallback((stations?: IStation[], updatedStation?: IStation) => {
    if (!stations || !updatedStation) {
      return stations || EMPTY_ARRAY;
    }

    const copiedStations = [...stations];
    const index = copiedStations.findIndex(item => item.code === updatedStation.code);
    if (index !== undefined ) {
      copiedStations[index] = { ...updatedStation };
    }
    return copiedStations;
  }, []);

  const addFavouriteStation = useCallback(async (stationCode: string) => {
    await addFavouriteStations([stationCode]);
    getFavouriteStations();
    const station = getStationByCode(stationCode);
    if (station) {
      const updatedStation = { ...station, favourite: true };
      updateStations(changeStations(stations, updatedStation));
      updateAllStations(changeStations(allStations, updatedStation));
    }
    logAmplitudeEvent(STATIONS_AMPLITUDE_EVENTS.addFavouriteServicePoint, { extra: { stationCode } });
  }, [
    addFavouriteStations,
    getFavouriteStations,
    getStationByCode,
    updateStations,
    stations,
    changeStations,
    allStations,
    updateAllStations
  ]);

  return addFavouriteStation;
};
